import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    color: theme.palette.text.primary
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  Row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8
  },
  check: { marginRight: 4 },
  checkbox: {
    padding: 1
  },
  text: {
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem'
    },
    color: theme.palette.text.primary
  },
  checkboxLabel: {
    margin: 0,
    '& .MuiCheckbox-root': {
      padding: theme.spacing(0.5)
    }
  },
  showMoreButton: {
    alignSelf: 'flex-start',
    padding: 0,
    minWidth: 'auto',
    fontSize: '0.8rem',
    textTransform: 'none'
  },
  optionRow: {
    cursor: 'pointer'
  }
}))

export default useStyles
